"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillTagSelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const icons_1 = require("@ant-design/icons");
const Api = __importStar(require("@src/api"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const normalize_string_1 = require("@src/helpers/normalize-string");
const antd_1 = require("antd");
const SkillTagSelect_style_1 = require("./SkillTagSelect.style");
const SkillTagSelect = ({ selectedSkills, setSkills, maxTagCount, options, selectPlaceholder, oppositeSelectedSkills, isSkillPrimary, setOptions, }) => {
    const [searchValue, setSearchValue] = react_1.default.useState('');
    const [isLoading, setIsLoading] = react_1.default.useState(false);
    const intl = (0, react_intl_1.useIntl)();
    const areOptionsEmpty = options.length === 0;
    const areSelectedSkillsOverLimit = selectedSkills.length >= maxTagCount;
    const shouldHideDropdown = (areOptionsEmpty && !searchValue) || areSelectedSkillsOverLimit;
    const maxTagTextLength = 30;
    const onSearch = async (otherSelectSkills, searchText, actualSelectedSkills) => {
        try {
            setIsLoading(true);
            const normalizedSearchedText = searchText ? (0, normalize_string_1.normalizeStr)(searchText) : undefined;
            if (!normalizedSearchedText) {
                setOptions([]);
                return;
            }
            const { allSkillTags } = await Api.SkillTag.getAutoCompleteSkillTags(normalizedSearchedText, [...actualSelectedSkills, ...otherSelectSkills]);
            setOptions(allSkillTags);
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setIsLoading(false);
        }
    };
    const addExpression = async () => {
        try {
            const trimmedSearchValue = searchValue.trim();
            if (!trimmedSearchValue) {
                setOptions([]);
                setSearchValue('');
                return;
            }
            const { skillTagToFind } = await Api.SkillTag.getSingleSkillTag(trimmedSearchValue);
            let newOption;
            if (skillTagToFind) {
                const { name: tagName } = skillTagToFind;
                newOption = { value: tagName, label: tagName, key: tagName };
            }
            else {
                newOption = {
                    value: trimmedSearchValue,
                    label: trimmedSearchValue,
                    key: trimmedSearchValue,
                };
            }
            const isTagAlreadySelected = Boolean([...selectedSkills, ...oppositeSelectedSkills].find(({ value }) => (0, normalize_string_1.normalizeStr)(value) === (0, normalize_string_1.normalizeStr)(newOption.value)));
            setSearchValue('');
            if (isTagAlreadySelected) {
                antd_1.notification.warning({
                    message: intl.formatMessage({
                        id: 'general.warning',
                    }),
                    description: intl.formatMessage({
                        id: 'profile.resume.skill.duplicate_skill_warning',
                    }),
                });
                setOptions([]);
                return;
            }
            const newSelectedSkills = [
                ...(selectedSkills || []),
                { ...newOption, isPrimary: isSkillPrimary, rating: 1 },
            ];
            setSkills(newSelectedSkills);
            setOptions([]);
        }
        catch (err) {
            console.error(err);
        }
    };
    const debounceOnSearch = react_1.default.useCallback((0, debounce_1.default)(onSearch, 300), []);
    return ((0, jsx_runtime_1.jsx)(SkillTagSelect_style_1.CustomSkillTagSelect, { mode: "multiple", open: true, dropdownClassName: shouldHideDropdown ? 'hidden' : '', placeholder: selectPlaceholder, labelInValue: true, loading: isLoading, onSearch: inputTextValue => {
            let inputText = inputTextValue;
            const isInputTooLong = inputText.length > maxTagTextLength;
            if (inputText === ',') {
                return;
            }
            if (inputTextValue[inputTextValue.length - 1] === ',') {
                addExpression();
            }
            if (inputText.includes(',')) {
                inputText = inputText.substring(0, inputText.indexOf(','));
            }
            if (isInputTooLong) {
                inputText = inputText.substring(0, maxTagTextLength);
            }
            if (!areSelectedSkillsOverLimit) {
                setSearchValue(inputText);
                debounceOnSearch(oppositeSelectedSkills, inputText, selectedSkills);
            }
        }, searchValue: searchValue, onSelect: skillItem => {
            const newSkillItem = { ...skillItem, isPrimary: isSkillPrimary, rating: 1 };
            setSearchValue('');
            setOptions([]);
            setSkills([...selectedSkills, newSkillItem]);
        }, onDeselect: ({ value }) => {
            setSkills(selectedSkills.filter(skill => skill.value !== value));
        }, filterOption: false, value: selectedSkills, options: options, maxTagTextLength: maxTagTextLength, dropdownRender: menu => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [searchValue && ((0, jsx_runtime_1.jsx)(SkillTagSelect_style_1.AddExpressionButton, { type: "text", size: "middle", className: "p-b-xs p-t-xs p-l-s p-r-s flex-row align-center", icon: (0, jsx_runtime_1.jsx)(icons_1.PlusOutlined, { className: "m-r-s" }), onClick: addExpression, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.tag_add_expression" }) })), !areOptionsEmpty && !isLoading && (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: menu }), isLoading && (0, jsx_runtime_1.jsx)(SkillTagSelect_style_1.SpinnerWrapper, { size: "large", delay: 200 })] })) }));
};
exports.SkillTagSelect = SkillTagSelect;
